<template>
    <div class>
        <LoadingDots v-show="loading" />
        <CategoryMenu
            v-for="rattachment in rattachments"
            :class="{ 'rattachment--closed': rattachment.isclosed !== false }"
            :key="rattachment.id"
            :category="rattachment"
            :opened="rattachment.opened"
            class="category--rattachment"
        >
            <div
                v-for="object in rattachment.objects"
                :key="object[`${rattachment.fid}${fidSufix}`]"
                class="rattachment-object"
                :class="{
                    'display--object': isActiveObject(rattachment, object),
                }"
                @click.self="displayObject(rattachment, object)"
            >
                {{ object[`${rattachment.fid}${fidSufix}`] }}
            </div>
            <div
                v-if="rattachment.objects.length === 0"
                class="rattachment-object"
                style="cursor: initial"
            >
                Aucun objet disponible
            </div>
        </CategoryMenu>
    </div>
</template>

<script>
import LoadingDots from '@/components/LoadingDots';
import CategoryMenu from '@/components/CategoryMenu';

export default {
    data() {
        return {
            fidSufix: this.inverse === true ? '' : '_old_rattachment',
        };
    },
    props: {
        rattachments: Array,
        loading: Boolean,
        activeObject: Object,
        value: Array,
        inverse: { type: Boolean, default: false },
    },
    methods: {
        displayObject: function(rattachment, object) {
            this.$emit('display:object', {
                rattachment,
                object,
            });
        },
        isActiveObject: function(rattachment, object) {
            if (
                rattachment &&
                object &&
                this.activeObject &&
                this.activeObject.rattachment &&
                this.activeObject.rattachment.id === rattachment.id
            ) {
                if (this.activeObject && this.activeObject.objects) {
                    for (let i = 0; i < this.activeObject.objects.length; i++) {
                        const obj = this.activeObject.objects[i];
                        if (
                            obj &&
                            obj[`${rattachment.fid}${this.fidSufix}`] &&
                            obj[`${rattachment.fid}${this.fidSufix}`] ===
                                object[`${rattachment.fid}${this.fidSufix}`]
                        ) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },
    },
    components: {
        LoadingDots,
        CategoryMenu,
    },
};
</script>

<style lang="scss">
.rattachment--closed {
    display: none;
}
.category--rattachment {
    .category-title-button {
        padding: 8px 18px 8px 20px;
        background-color: #f6f7f8;

        &:hover {
            background-color: #ebedef;
        }
    }
}

.category--object {
    .category-title-button {
        padding: 6px 18px 6px 30px;
        background-color: #ffffff;

        &:hover {
            background-color: #f9f9fa;
        }
    }
}

.rattachment-object {
    cursor: pointer;
    // color: #9ca5b0;
    font-size: 13px;
    line-height: 18px;
    padding: 6px 18px 6px 45px;
    // border-left: none;
    position: relative;

    &:hover {
        background-color: #f9f9fa;
    }

    &.display--object {
        color: #6c3e91;
        font-size: 13px;
        font-weight: 600;
        padding-left: 42px;
        border-left: 3px solid #6c3e91;
    }
}
</style>
